import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-candidate-success',
  templateUrl: './candidate-success.component.html',
  styleUrls: ['./candidate-success.component.css']
})
export class CandidateSuccessComponent implements OnInit {

  requestNumber: any;
  uuid: any;
  data: any;
  hrUserEmail:string;
  userData:any;
  companyName:string;

  constructor(
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private pageTitleService: PageTitleService,
    private reportService: ReportService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.pageTitleService.setTitle("Success");

    this.requestNumber = this.route.snapshot.paramMap.get('requestNumber');

    this.uuid = this.route.snapshot.paramMap.get('uuid');

    this.reportService.validateUUID(this.requestNumber, this.uuid).subscribe(data => {
      /* console.log(data); */
      this.data = data;
      if (this.data) {
        this.hrUserEmail = this.data.hrUserEmail;

        if (this.hrUserEmail !== null) {
          let dataJson = {
            'email': this.hrUserEmail
          }
          this.userService.getHrUserDetailsForCandidatePrivacy(dataJson).subscribe(userData => {
            this.userData = userData;
            /* console.log(this.userData); */
            this.companyName = this.userData.companyName;
          });
        }
      }
      this.spinnerService.stop();
    });
  }

}
